import { sortMapByStringValue } from "./sort"

export const parseAndSetFylkerOgKommuner = (
  data: FylkerOgKommuner
): AreaMappings => {
  const fylkeNrTilKommuneMap = new Map<number, Map<string, number>>()
  let fylkeNrTilFylkeNavn = new Map<number, string>()
  let fylkeNavnTilFylkeNr = new Map<string, number>()
  data.fylkerMedKommuner.forEach(fylke => {
    const fylkekommuner = new Map<string, number>()
    fylke.kommuner.forEach(kommune => {
      fylkekommuner.set(kommune.navn, kommune.nummer)
    })
    fylkeNrTilKommuneMap.set(fylke.nummer, fylkekommuner)
    fylkeNrTilFylkeNavn.set(fylke.nummer, fylke.navn)
    fylkeNavnTilFylkeNr.set(fylke.navn, fylke.nummer)
  })
  const kommuneNavnTilNr = new Map<string, number>()
  data.kommuner.forEach(kommune => {
    kommuneNavnTilNr.set(kommune.navn, kommune.nummer)
  })
  fylkeNrTilFylkeNavn = sortMapByStringValue(fylkeNrTilFylkeNavn)
  const areaMappings: AreaMappings = {
    fylkeNrTilKommuneMap: fylkeNrTilKommuneMap,
    fylkeNrTilFylkeNavn: fylkeNrTilFylkeNavn,
    fylkeNavnTilFylkeNr: fylkeNavnTilFylkeNr,
    kommuneNavnTilNr: kommuneNavnTilNr,
    fylkeMedKommuner: data.fylkerMedKommuner,
    kommuner: data.kommuner,
  }
  return areaMappings
}

export interface AreaMappings {
  fylkeNrTilKommuneMap: Map<number, Map<string, number>>
  fylkeNrTilFylkeNavn: Map<number, string>
  fylkeNavnTilFylkeNr: Map<string, number>
  kommuneNavnTilNr: Map<string, number>
  fylkeMedKommuner: FylkeMedKommuner[]
  kommuner: Område[]
}

export interface FylkerOgKommuner {
  fylker: Array<Område>
  fylkerMedKommuner: Array<FylkeMedKommuner>
  kommuner: Array<Område>
}

export interface FylkeMedKommuner {
  navn: string
  nummer: number
  kommuner: Array<Område>
}

export interface Område {
  navn: string
  nummer: number
}
